import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";
import { createStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        backdrop: {
            top: 108,
            left: 284,
            backdropFilter: "blur(5px)",
            backgroundColor: "rgba(255, 255, 255, 0.15)",
        },
        modalWrapper: {
            background: "white",
            boxShadow: "0px 6px 18px 1px rgba(0, 0, 0, 0.25)",
            position: "absolute",
            width: 576,
            borderRadius: "8px",
            padding: theme.spacing(2),
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 1000,
        },
        tabStyle: {
            ".MuiTab-root": {
                textTransform: "none",
            },
            ".Mui-selected": {
                color: theme.palette.button.active.from,
                fontWeight: 700,
            },
        },
        description: {
            color: theme.palette.secondary.main,
            margin: theme.spacing(2, 0),
        },
        formContainer: {
            background: theme.palette.background.grey,
            borderRadius: "8px",
            maxHeight: 400,
            overflow: "overlay",
        },
        controlLabel: {
            paddingLeft: theme.spacing(1),
            "& .MuiFormControlLabel-label": {
                fontSize: 10,
                fontWeight: 500,
            },
        },
        textField: {
            "& .MuiInputBase-root": {
                borderRadius: "22px",
                padding: theme.spacing(1, 2),
            },
            "& .MuiInputBase-input": {
                fontSize: 10,
            },
            "& .MuiInput-underline:before": {
                borderBottom: "none",
            },
            "& .MuiInput-underline:after": {
                borderBottom: "none",
            },
            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                borderBottom: "none",
            },
            "& .MuiInput-underline:hover:not(.Mui-disabled):after": {
                borderBottom: "none",
            },
            "& .MuiInputBase-root.Mui-error": {
                border: `1px solid ${theme.palette.error.main} !important`,
                borderRadius: "22px",
            },
        },
        messageTextField: {
            "& .MuiInputBase-root": {
                borderRadius: "31px",
                padding: theme.spacing(1, 2),
            },
            "& .MuiInputBase-input": {
                fontSize: 10,
            },
            "& .MuiInput-underline:before": {
                borderBottom: "none",
            },
            "& .MuiInput-underline:after": {
                borderBottom: "none",
            },
            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                borderBottom: "none",
            },
            "& .MuiInput-underline:hover:not(.Mui-disabled):after": {
                borderBottom: "none",
            },
        },
        addIcon: {
            fontSize: 16,
            color: theme.palette.button.active.from,
            marginRight: theme.spacing(0.5),
        },
        linkButton: {
            textDecoration: "underline",
            cursor: "pointer",
            color: theme.palette.secondary.main,
            textUnderlineOffset: "4px",
            padding: 0,
            minWidth: "auto",
        },
        removeButton: {
            marginTop: theme.spacing(3),
            width: theme.spacing(3),
            color: theme.palette.primary.main,
            opacity: "25%",
            "&:hover": {
                opacity: "80%",
            },
            marginRight: theme.spacing(1),
        },
        sortButton: {
            alignSelf: "center",
            fontSize: 14,
            color: theme.palette.neutrals.dark,
            marginRight: theme.spacing(0.5),
        },
        tableRow: {
            "& .MuiTableCell-root": {
                borderBottom: `1px solid ${theme.palette.neutrals.light}`,
            },
        },
        tableCell: {
            background: theme.palette.background.grey,
            "&:first-child": {
                width: "68%",
                padding: theme.spacing(0, 0.5),
            },
            "&:last-child": {
                padding: theme.spacing(0, 0.5),
                width: "32%",
            },
        },
        tooltipWrapper: {
            display: "flex",
            alignItems: "center",
            marginRight: 0.5,
        },
        warningIcon: {
            fontSize: 14,
        },
    })
);

export default useStyles;
